import { motion } from 'framer-motion';
import { vars } from '../../theme';
import React from 'react';
import styled from 'styled-components';
import { TSize } from '../../tokens/types';

export interface Props {
    /** Fill percentage of the progress bar (0-100), animated from the minimum width to the target. */
    percent: number;
    /** Animation duration in seconds for the fill transition. */
    duration?: number;
    /** Bar thickness: 'sm' renders a 6px bar, 'md' renders a 20px bar. */
    size?: Extract<TSize, 'sm' | 'md'>;
    /** CSS class applied to the root element. */
    className?: string;
}

const SIZES = {
    sm: '6px',
    md: '20px'
} as const;

const HBProgressBar = ({
    className,
    percent,
    duration = 1,
    size = 'md'
}: Props) => {
    const _size = SIZES[size];
    return (
        <Container className={className}>
            <Bar
                size={_size}
                initial={{ width: _size }}
                animate={{ width: `${percent}%` }}
                transition={{
                    ease: 'easeInOut',
                    duration
                }}
            />
        </Container>
    );
};

export default HBProgressBar;

// -------------------------- Styles -------------------------- //

const Container = styled.div`
    background-color: ${vars.colors.surface.neutral};
    border-radius: ${vars.radius.full};
`;

const Bar = styled(motion.div)<{ size: string }>`
    height: ${props => props.size};
    min-width: ${props => props.size};
    max-width: 100%;
    background-color: ${vars.colors.base.accent};
    border-radius: inherit;
`;
